import { PROVIDERS, WEEKPLAN } from "../config"
import CardHeadline from "./elements/CardHeadline"

interface FiveFourTileProps {
	debugDay?: number
}

const FiveFourTile: React.FC<FiveFourTileProps> = ({ debugDay = null }) => {
	const d = new Date()
	let dayContent

	if (typeof debugDay === "number") {
		dayContent = WEEKPLAN.filter(weekday => weekday.getDay === debugDay)[0]
	} else {
		dayContent = WEEKPLAN.filter(weekday => weekday.getDay === d.getDay())[0]
	}
	console.log(debugDay, { dayContent })

	return (
		<>
			{/* Mobile */}
			<div className="relative block md:hidden">
				<CardHeadline dayContent={dayContent} className="absolute top-[10%] px-4 text-center w-full " />

				<div className="w-[142px] lg:w-1/3 absolute left-[5%] bottom-[3%] h-[26.6%] bg-[url(/public/images/boxHeute.png)] bg-contain bg-center bg-no-repeat">
					<svg className="absolute top-[46%] left-0 w-full" viewBox="0 0 332 130" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
						<text x="50%" y="22%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
							Immer
						</text>
						<text x="50%" y="62%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
							{dayContent.day}s
						</text>
					</svg>
				</div>

				<div className="w-[27%] absolute left-[8%] bottom-[5%] h-[21%] "></div>
				<img src={"images/providers/" + dayContent.provider + "-mobile.webp"} className="w-full h-auto" alt="" />
			</div>

			{/* Desktop */}
			<div className={"relative hidden md:block bg-cover bg-right"} style={{ backgroundImage: "url(images/providers/" + dayContent.provider + ".webp)" }}>
				<div className="mx-auto max-w-6xl px-4 py-12">
					<CardHeadline dayContent={dayContent} className="pb-[10%] text-left" />

					<div className="grid grid-cols-[235px_1fr] gap-6">
						<div className="w-full top-[-25px] relative h-[235px] bg-[url(/public/images/boxHeute.png)] bg-contain bg-no-repeat">
							<svg className="absolute top-[46%] left-0 w-full" viewBox="0 0 332 130" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
								<text x="50%" y="22%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
									Immer
								</text>
								<text x="50%" y="62%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
									{dayContent.day}s
								</text>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default FiveFourTile
